import React, {FC, memo, useCallback, useState} from "react";
import {Button, FloatingLabel, Form} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {AuthContainer, Border, ButtonGroup, Container} from "./LoginStyle";
import MainLabel from "../../../component/mainLabel/MainLabel";
import {fetchToken, ITokenRequest} from "../../../fetch/AuthRequest";
import {IToken, actions as actionToken} from "../../../store/sliceToken";
import {actions} from "../../../store/sliceModal";
import {AppDispatch} from "../../../store/configureStore";
import {useDispatch} from "react-redux";
import FormCode from "../../../component/formCode/FormCode";
import {config} from "../../../config";

const Login: FC = () => {

    const nav = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')

    const submitHandler = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (login.length === 0 || password.length === 0) {
            return;
        }
        fetchToken({
            grant_type: 'password',
            username: login,
            password: password
        } as ITokenRequest).then(response => {
            if (response.status === 200) {
                const token: IToken = response.data;
                dispatch(actionToken.saveToken(token))
                if (token.access_token) {
                    // nav(`${config.url}`)
                    nav(`/`)
                } else {
                    nav(`${config.uiStart}/code`)
                }
            } else {
                dispatch(actions.showError(response.data))
            }
            setLogin('')
            setPassword('')
        })
    }, [login, password])


    const loginHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setLogin(e.target.value);
    }, [login])

    const passwordHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    }, [password])


    const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLFormElement>) => {
        if (e.key === 'Enter') {
            submitHandler(e)
        }
    }, [login, password])


    return (
        <Container as={"main"}>
            {/*<Col as={"section"} xl={4} lg={4} md={6} sm={8} xs={9} style={{justifySelf: "center"}}>*/}
            <AuthContainer>
                <Border>
                    <MainLabel/>
                    <Form
                        onSubmit={submitHandler}
                        // onKeyDown={onKeyDown}
                    >
                        <FloatingLabel
                            label="Логин"
                            style={{fontSize: "15px", padding: 0, marginBottom: "20px"}}
                        >
                            <Form.Control as={"input"} required type="text" placeholder="Login"
                                          style={{fontSize: "20px"}}
                                          onChange={loginHandler}
                                          value={login}
                            />
                        </FloatingLabel>
                        <FloatingLabel
                            label="Пароль"
                            style={{fontSize: "15px", padding: 0, marginBottom: "20px"}}
                        >
                            <Form.Control as={"input"} required type="password" placeholder="password" style={{fontSize: "20px"}}
                                          onChange={passwordHandler}
                                          value={password}
                            />
                        </FloatingLabel>
                        <ButtonGroup>
                            <Button variant="outline-primary" type={"submit"}>Войти</Button>
                            <Button variant="outline-secondary" type={"submit"} hidden={true}
                                    onClick={e => nav("/registration")}>Регистрация</Button>
                        </ButtonGroup>
                    </Form>
                    {/*{inputCode && <FormCode token={token} rollback={() => setInputCode(false)}/>}*/}
                </Border>
            </AuthContainer>
            {/*</Col>*/}
        </Container>
    )
}

export default memo(Login);
